import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthHelper from 'utils/authHelper';

const PrivateRoute = ({
  component: Component,
  unauthorizedPathname = '/login',
  ...rest
}) => {
  const isAuthenticated = useSelector((state) =>
    AuthHelper.isAuthenticated(state.auth),
  );

  // Another safeguard. See containers/Login/index.js
  const passwordResetToken = useSelector(
    (state) => state.auth.passwordResetToken,
  );

  return (
    <Route
      {...rest}
      render={(props) =>
        passwordResetToken ? (
          <Redirect
            to={{
              pathname: '/password-reset',
              search: `?token=${passwordResetToken}`,
              state: { from: props.location },
            }}
          />
        ) : isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: unauthorizedPathname,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
